// extracted by mini-css-extract-plugin
export var orderSummary = "_tu-0";
export var showMoreLessButton = "_tu-1";